import { usePermissions } from 'react-admin';
import { Navigate } from 'react-router-dom';
import { Dashboard } from './Dashboard';
import { NARROW_ROLES, ROLE } from '../providers/auth.types';

// GH-724 — narrow roles (e.g. 'expert-manager') are not allowed to call the dashboard's stats
// endpoints, so instead of a page full of 403s they land on the experts list.
export const DashboardGate = () => {
	const { permissions, isLoading } = usePermissions<ROLE>();
	if (isLoading) return null;
	if (permissions && NARROW_ROLES.includes(permissions)) return <Navigate to="/instructor/allin/experts" replace />;
	return <Dashboard />;
};
